import { Component, OnInit, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
HC_exporting(Highcharts);
declare var $: any;
import * as moment from 'moment';
import { ScheduleService } from 'src/app/api/departure/schedule.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';

@Component({
  selector: 'app-schedule-projection',
  templateUrl: './schedule-projection.component.html',
  styleUrls: ['./schedule-projection.component.css']
})
export class ScheduleProjectionComponent implements OnInit {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  private thisComponent: ScheduleProjectionComponent;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  chart: Highcharts.Chart | undefined;
  updateFlag: boolean = false; // Flag para forzar la actualización

  date_range: any = null;
  tour: any = null;
  bookings: any = [];
  start_range: any = moment();
  end_range: any = moment().endOf('month');

  constructor(private scheduleService: ScheduleService) {
    this.thisComponent = this;
  }

  ngOnInit() {
    this.generateCalendar();
    this.generateGraph();
  }

  generateCalendar(){
    let component_ = this.thisComponent;
    (<any>$('#date_range_projection')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD'
        },
        ranges: {
          'Actual - Fin Mes': [moment(), moment().endOf('month')],
          'Siguiente Mes': [
            moment()
              .add(1, 'month')
              .startOf('month'),
            moment()
              .add(1, 'month')
              .endOf('month')
          ],
          'Tercer Mes': [
            moment()
              .add(2, 'month')
              .startOf('month'),
            moment()
              .add(2, 'month')
              .endOf('month')
          ]
        },
        startDate: component_.start_range,
        endDate: component_.end_range,
        showCustomRangeLabel: false, // Desactivar la opción de rangos personalizados
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
        component_.resetGraph();
        component_.init();
      }
    );
  }

  resetGraph() {
    if (this.chart) {
      // Eliminar todas las series
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false); // Eliminar la primera serie hasta que no haya más
      }

      // Desactivar la leyenda
      this.chart.update({
        legend: {
          enabled: false // Desactivar la leyenda
        }
      });

      // Redibujar el gráfico
      this.chart.redraw();
    }
  }

  init() {
    this.LoadingModalComponent.show();
    let val_params =
      'start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD');

    this.scheduleService.listProjection(val_params).subscribe({
      next: (data: any) => {
        let tours = data.tours;
        let results = data.results;
        let series: any = [];
        for (let i in tours) {
          let obj_: any = {
            name: tours[i].description
            // type: 'line'
          };
          let arr_temp_data: any = [];
          let arr_daynumber: any = [];
          for (let j in results) {
            if (tours[i].id == results[j].tour_id) {
              arr_temp_data.push(Number(results[j].total_quantity));
              arr_daynumber.push(Number(results[j].day_number));
            }
          }

          obj_.temp_data = arr_temp_data;
          obj_.day_number = arr_daynumber;
          obj_.data = [];
          series.push(obj_);
        }

        for (let i in series) {
          let currentDate = this.start_range.clone();;
          const endOfMonth = this.end_range;
          let arr_data: any = [];
          if (series[i].day_number.length > 0) {
            while (currentDate.isSameOrBefore(endOfMonth)) {
              let exist = true;
              for (let j in series[i].day_number) {
                if (
                  Number(currentDate.format('D')) == series[i].day_number[j]
                ) {
                  arr_data.push(series[i].temp_data[j]);
                  exist = false;
                  break;
                }
              }
              if (exist) {
                arr_data.push(0);
              }
              currentDate.add(1, 'day'); // Avanza al siguiente día
            }
          } else {
            while (currentDate.isSameOrBefore(endOfMonth)) {
              arr_data.push(null);
              currentDate.add(1, 'day'); // Avanza al siguiente día
            }
          }
          series[i].data = arr_data;
        }
        setTimeout(() => {
          this.updateChartData(series);
        }, 150);
      }
    });
  }

  generateGraph(series_data: any = []) {
    this.chartOptions = {
      chart: {
        type: 'line',
        marginTop: 100
      },
      title: {
        text:
          'Proyección Salidas Tours mes ' +
          moment(this.start_range)
            .locale('es')
            .format('MMMM')
            .toUpperCase() +
          ' ' +
          this.start_range.format('YYYY'),
        style: {
          fontSize: '1em'
        },
        align: 'left'
      },
      // subtitle: {
      //   text:
      //     'By Job Category. Source: <a href="https://irecusa.org/programs/solar-jobs-census/" target="_blank">IREC</a>.',
      //   align: 'left'
      // },
      tooltip: {
        headerFormat:
          '<div class="text-center"><b>FECHA:{point.key}</b></div><br/>', // Muestra el valor de xAxis
        pointFormat: '{series.name}: <b>{point.y:0f} pax</b>',
        // pointFormat: 'N°: <b>{point.y:0f} pax</b>',
        style: {
          color: '#333333', // Color del texto
          fontSize: '12px',
          fontFamily: 'Arial' // Familia de fuente
        }
      },
      yAxis: {
        title: {
          text: 'N° de Pasajeros'
        }
      },
      xAxis: {
        title: {
          text:
            'Rango de fechas (' +
            this.start_range.format('YYYY-MM-DD') +
            ' - ' +
            this.end_range.format('YYYY-MM-DD') +
            ')',
          y: 10 // Ajusta este valor para desplazar el texto hacia abajo
        }
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        itemStyle: {
          fontSize: '11px'
        }
      },
      plotOptions: {
        series: {
          cursor: 'pointer',
          label: {
            connectorAllowed: false
          },
          pointStart: Number(this.start_range.date())
        }
      },
      series: series_data,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }
        ]
      }
    };
  }

  updateChartData(series: any) {
    // Si la referencia del gráfico está disponible, actualiza las series
    if (this.chart) {
      this.chart.series.forEach((serie: Highcharts.Series) => {
        serie.remove(false); // Eliminar series antiguas sin redibujar
      });

      // Añadir cada serie con los datos nuevos
      series.forEach((serieData: any) => {
        this.chart?.addSeries(
          {
            type: 'line', // Especificar el tipo de serie aquí
            name: serieData.name,
            data: serieData.data,
            visible: serieData.day_number.length > 0 // Mostrar solo si hay datos en day_number
          } as Highcharts.SeriesOptionsType,
          false
        ); // No redibujar aún
      });

      this.chart.update({
        title: {
          text:
            'Proyección Salidas Tours mes ' +
            moment(this.start_range)
              .locale('es')
              .format('MMMM')
              .toUpperCase() +
            ' ' +
            this.start_range.format('YYYY'),
          style: {
            fontSize: '1em'
          }
        },
        xAxis: {
          title: {
            text:
              'Rango de fechas (' +
              this.start_range.format('YYYY-MM-DD') +
              ' - ' +
              this.end_range.format('YYYY-MM-DD') +
              ')'
          },
          offset: 10
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            label: {
              connectorAllowed: false
            },
            pointStart: Number(this.start_range.date()) // Usar el valor dinámico de `pointStart`
          }
        },
        legend: {
          enabled: true // Desactivar la leyenda si no la deseas
        }
      });

      // this.chart.update({
      //   legend: {
      //     enabled: true // activar la leyenda
      //   }
      // });

      this.chart.redraw(); // Redibujar el gráfico con las nuevas series
      this.LoadingModalComponent.hide();
    }
  }

  // Recibir la referencia del gráfico cuando se crea
  onChartInstance(chartInstance: Highcharts.Chart) {
    this.chart = chartInstance;
  }

  close() {
    setTimeout(() => {
      this.start_range = moment();
      this.end_range = moment().endOf('month');
      this.generateCalendar();
      this.resetGraph();
    }, 250);
  }

}
